// project imports
import { DICCIONARIOS, IDIOMA_POR_DEFECTO, resolveLocale } from './index';

const PLACEHOLDER = /\{\{(\w+)\}\}/g;

/**
 * Traduce `key` al idioma pedido e interpola `{{parametros}}`.
 *
 * La cadena de respaldo es deliberada: idioma pedido -> idioma por defecto ->
 * la propia clave. Una traducción a medias muestra el texto en español, no la
 * clave cruda; y si la clave no existe en ningún diccionario, devolverla hace
 * que el hueco se note en pantalla y en las pruebas en vez de pasar por un
 * texto vacío silencioso.
 */
export function translate(locale, key, params) {
  const codigo = resolveLocale(locale);
  const texto = DICCIONARIOS[codigo]?.[key] ?? DICCIONARIOS[IDIOMA_POR_DEFECTO][key] ?? key;

  if (!params) return texto;

  return texto.replace(PLACEHOLDER, (original, nombre) => (nombre in params ? String(params[nombre]) : original));
}
